import { userApis } from '@apis/userApis';
import { useMutation } from '@hooks/useMutation';

export const useResendEmail = () => {
  return useMutation(async (body: { email: string }) => {
    const response = await userApis.post('/registration/resend-email/', { body });
    return response[200]!;
  });
};
